export default class Login{
    email = "";
    senha = "";
}



// WEBPACK FOOTER //
// ./src/model/Login.js